import React from 'react'
import { Row, Col, Button, notification, Select, Divider, Form, Input, Switch, Spin } from 'antd'
import API from '../../../services/API'
import Segment from '../../../components/Segment'
import Search from '../../../components/Search'
import { onKeyPressNumbers, onKeyMoney } from '../../../services/Utils'
import { Link } from 'react-router-dom'

const { Option } = Select
const INIT = {
    social_reason: '',
    name: '',
    last_name: '',
    email: '',
    phone: '',
    credit_limit: '',
    active: true,
    customer_type_id: null,
    rfc: '',
    cfdi: '',
    tax_regime: '',
    business_name: '',
    billing_number_ext: '',
    billing_number_int: '',
    billing_address: '',
    billing_email: '',
    billing_zipcode: '',
    accountable_type: '',
    id: null,
    unique_id: '',
}

const CustomersEditContainer = ({ match }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const [suburbs, setSuburbs] = React.useState([])
    const [currenSearchCustomerType, setCurrenSearchCustomerType] = React.useState('')
    const [currentSearchCfdiUsages, setCurrentSearchCfdiUsages] = React.useState('')
    const [currentSearchTaxRegimes, setCurrentSearchTaxRegimes] = React.useState(false)

    const disabled =
        !data.social_reason || !data.customer_type_id || !data.phone || !data.email || !data.cfdi || !data.tax_regime


    const generateUniqueId = ()=> {
       const minLength = 19;
       const maxLength = 23;
       let uniqueId = '';
       while (uniqueId.length < minLength) {
           uniqueId += Math.floor(Math.random() * 10);
       }
       if (uniqueId.length > maxLength) {
           uniqueId = uniqueId.slice(0, maxLength);
       }
       return uniqueId;
    }

    const getSuburbs = zipcode => {
        setloading(true)
        API.get(`/api/suburbs/zipcode/${zipcode}`)
            .then(response => {
                setloading(false)
                if (response.data && response.data.data) {
                    setSuburbs(response.data.data)
                }
            })
            .catch(error => {
                setloading(false)
                console.error(error)
            })
    }

    const getData = () => {
        API.get(`/api/customers/${match.params.id}`)
            .then(response => {
                if (response.data) {
                    setData({
                        ...response.data,
                        credit_limit: response.data.credit_limit == null ? 0 : response.data.credit_limit,
                    })
                    if (response.data.customer_type) {
                        setCurrenSearchCustomerType(response.data.customer_type.name)
                    }

                    if (response.data.cfdi) {
                        setCurrentSearchCfdiUsages(response.data.cfdi)
                    }

                    if (response.data.tax_regime) {
                        setCurrentSearchTaxRegimes(response.data.tax_regime)
                    }

                    if(response.data.billing_zipcode){
                        getSuburbs(response.data.billing_zipcode)
                    }

                }
            })
            .catch(error => {
                console.error(error)
            })
    }

    React.useEffect(() => {
        getData()
    }, [])

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const handleSubmit = () => {
        setloading(true)
        if(data.id && (data?.unique_id === null || data?.unique_id === '')){
            data.unique_id = generateUniqueId();
        }
        console.log('is data',data);
        API.patch(`/api/customers/${match.params.id}`, data)
            .then(response => {
                setloading(false)
                if (response.data) {
                    notification.success({
                        message: 'El cliente se ha modificado exitosamente',
                    })
                }
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Editar cliente</Divider>
            <Form style={{ maxWidth: '800px', margin: 'auto' }}>
                <p className="message">
                    Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben ser
                    llenados.
                </p>
                <Row gutter={24}>
                    <Col lg={24} md={24} sm={24}>
                        <Form.Item label="Razón social" className="required" hasFeedback>
                            <Input
                                id="social_reason"
                                placeholder="Razón social"
                                value={data.social_reason}
                                onChange={e => {
                                    handleChange('social_reason', e.target.value.toUpperCase())
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={6} md={12} sm={12}>
                        <Form.Item label="Tipo de precio" className="required">
                            <Search
                                id="customer_type_id"
                                value={currenSearchCustomerType}
                                placeholder="Tipo de precio"
                                onSearch={value => '/api/customer_types?filter[active]=true'}
                                onChange={(key, value) => {
                                    console.log(value, 'some')
                                    setCurrenSearchCustomerType(value.name)
                                    handleChange('customer_type_id', key)
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={6} md={12} sm={24}>
                        <Form.Item label="Teléfono" className="required" hasFeedback>
                            <Input
                                id="phone"
                                placeholder="Teléfono"
                                value={data.phone}
                                onChange={e => {
                                    const value = e.target.value
                                    if (value.length <= 10) {
                                        handleChange('phone', value)
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Uso de CDFI" className="required" hasFeedback>
                            <Search
                                id="cfdi"
                                value={currentSearchCfdiUsages}
                                placeholder="Uso de CDFI"
                                onSearch={value => `/api/sat/cfdi_usages`}
                                label="full_description"
                                keyName="code"
                                onChange={(key, value) => {
                                    setCurrentSearchCfdiUsages(value.full_description)
                                    handleChange('cfdi', value.code)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Correo electrónico" className="required" hasFeedback>
                            <Input
                                id="cfdi"
                                placeholder="Correo electrónico"
                                value={data.email}
                                type="email"
                                onChange={e => {
                                    handleChange('email',  e.target.value.toLowerCase())
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="RFC" hasFeedback>
                            <Input
                                id="rfc"
                                placeholder="RFC"
                                value={data.rfc}
                                onChange={e => {
                                    handleChange('rfc', e.target.value.toUpperCase())
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Nombre comercial" hasFeedback>
                            <Input
                                id="business_name"
                                placeholder="Nombre comercial"
                                value={data.business_name}
                                onChange={e => {
                                    handleChange('business_name', e.target.value)
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Regimen fiscal" className="required" hasFeedback>
                            <Search
                                id="tax_regime"
                                value={currentSearchTaxRegimes}
                                placeholder="Regimen fiscal"
                                onSearch={value => `/api/sat/tax_regimes`}
                                label="full_description"
                                keyName="code"
                                onChange={(key, value) => {
                                    setCurrentSearchTaxRegimes(value.full_description)
                                    handleChange('tax_regime', value.code)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Domicilio fiscal" hasFeedback>
                            <Input
                                id="billing_address"
                                placeholder="Domicilio fiscal"
                                value={data.billing_address}
                                onChange={e => {
                                    handleChange('billing_address', e.target.value)
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={6} md={12} sm={24}>
                        <Form.Item label="Número interior" hasFeedback>
                            <Input
                                id="billing_number_int"
                                placeholder="Número interior"
                                value={data.billing_number_int}
                                onKeyPress={onKeyPressNumbers}
                                onChange={e => {
                                    const value = e.target.value
                                    if (value.length <= 8) {
                                        handleChange('billing_number_int', value)
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={6} md={12} sm={24}>
                        <Form.Item label="Número exterior" hasFeedback>
                            <Input
                                id="billing_number_ext"
                                placeholder="Número exterio"
                                value={data.billing_number_ext}
                                onKeyPress={onKeyPressNumbers}
                                onChange={e => {
                                    const value = e.target.value
                                    if (value.length <= 8) {
                                        handleChange('billing_number_ext', value)
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={6} md={12} sm={24}>
                        <Form.Item label="Código postal de facturación" hasFeedback>
                            <Input
                                id="billing_zipcode"
                                placeholder="Código postal de facturación"
                                value={data.billing_zipcode}
                                onKeyPress={onKeyPressNumbers}
                                onChange={e => {
                                    const value = e.target.value

                                    if (value.length <= 5) {
                                        handleChange('billing_zipcode', value)
                                    }

                                    if (value.length >= 5) {
                                        getSuburbs(value)
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                        <Form.Item label="Colonia de facturación">
                            <Select
                                id="billing_suburb_id"
                                showSearch
                                mode="default"
                                style={{ width: '100%' }}
                                value={data.billing_suburb_id || undefined}
                                placeholder="Colonia de facutracion"
                                optionFilterProp="children"
                                notFoundContent={
                                    loading ? <Spin style={{ margin: '0 auto' }} size="small" /> : 'No hay resultados'
                                }
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={key => {
                                    handleChange('billing_suburb_id', key)
                                }}
                            >
                                {suburbs.map(d => (
                                    <Option key={d.id} value={d.id}>
                                        {d.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Correo de facturación" hasFeedback>
                            <Input
                                id="billing_email"
                                placeholder="Correo de facturación"
                                value={data.billing_email}
                                onChange={e => {
                                    handleChange('billing_email', e.target.value)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={6} md={8} sm={24}>
                        <Form.Item label="Tipo de contribuyente" hasFeedback>
                            <Select
                                id="accountable_type"
                                showSearch
                                mode="default"
                                // style={{ width: '100%' }}
                                value={data.accountable_type || undefined}
                                placeholder="Tipo de contribuyente"
                                optionFilterProp="children"
                                notFoundContent={
                                    loading ? <Spin style={{ margin: '0 auto' }} size="small" /> : 'No hay resultados'
                                }
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={key => handleChange('accountable_type', key)}
                            >
                                <Option key="persona_fisica" value="persona_fisica">Persona física</Option>
                                <Option key="persona_moral" value="persona_moral">Persona moral</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={6} md={8} sm={24}>
                        <Form.Item label="Limite de credito" hasFeedback>
                            <Input
                                id="credit_limit"
                                placeholder="Limite de credito"
                                value={data.credit_limit}
                                onKeyPress={e => onKeyMoney(e, data.credit_limit)}
                                onChange={e => {
                                    handleChange('credit_limit', e.target.value)
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={6} md={8} sm={24}>
                        <Form.Item label="Activo">
                            <Switch
                                defaultChecked={!!data.active}
                                onChange={value => {
                                    handleChange('active', value)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>

                    <Form.Item>
                        <Link to="/customers">
                            <Button

                                icon="arrow-left"
                            >
                                Regresar
                            </Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            icon="save"
                            disabled={disabled}
                            onClick={handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>




            </Form>
        </Segment>
    )
}

export default CustomersEditContainer
